// Copyright (c) Docugami, Inc. All rights reserved.

import { DocumentHeaderCell } from 'components/reports/ReportGridDocumentTitleCell';
import React from 'react';

// Use the following code to use actual ag-grid type once we start https://classifyprocess.visualstudio.com/product/_workitems/edit/20723
// export type AgGridDocumentTitleColumnHeaderProps = CustomHeaderProps<IReportRow>;
type AgGridDocumentTitleColumnHeaderProps = {
    reportId: string;
    onRemoveAllEntries: () => void;
    canRemoveAllEntries: boolean;
};

const AgGridDocumentTitleColumnHeader: React.FC<AgGridDocumentTitleColumnHeaderProps> = (props) => {
    return <DocumentHeaderCell
                    reportId={props.reportId}
                    onRemoveAllEntries={props.onRemoveAllEntries}
                    canRemoveAllEntries={props.canRemoveAllEntries} />
};

export default AgGridDocumentTitleColumnHeader;
